/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TSaveFormModel,
  ISaveFormRequest,
  IMappers,
  ISaveFormResponse,
  ISaveFormResponseError,
  TSaveFormResponse,
} from './types';

const defaultConfig: TSaveFormModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'deal-rent-announcements',
  pathApi: '/v1/save-form/',
  hostType: 'ud-api',
} as TSaveFormModel;

function createSaveFormModel(parameters: ISaveFormRequest): TSaveFormModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ISaveFormOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: ISaveFormRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchSaveForm<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: ISaveFormOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TSaveFormResponse> {
  const { response, statusCode } = await httpApi.fetch(createSaveFormModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ISaveFormResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as ISaveFormResponseError);
    }
  }

  return { response, statusCode } as TSaveFormResponse;
}

export { defaultConfig, createSaveFormModel, fetchSaveForm };
